import { faFire } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { styled, css } from 'styled-components'

import { Tag, TagType } from '@b-stock/fe-core/bstock-react'
import { Shadows, Breakpoints, Colors } from '@b-stock/fe-core/design-system'

interface FmvDealBadgeProps {
  variant?: 'ldp' | 'card'
  'data-testid'?: string
}

// The "Hot Deal" badge only ever renders for the top FMV tier, so it has a
// single fixed treatment (no per-tier color logic).
const hotDealColorStyles = css`
  background-color: ${Colors.Semantic.SpecificFunctions.Rating.rating};
  color: ${Colors.Semantic.Neutral.black};
`

const LDPDealBadge = styled(Tag)`
  display: block;
  width: fit-content;
  margin: 0 2rem 0.75rem 2rem;
  ${Shadows.MultipleCards}
  outline: 0.0625rem solid rgba(20, 26, 30, 0.05);
  outline-offset: -0.0625rem;
  ${hotDealColorStyles}

  @media ${Breakpoints.max.medium} {
    margin-left: 1rem;
    margin-right: 1rem;
  }
`

const CardDealBadge = styled(Tag)`
  display: block;
  width: fit-content;
  ${Shadows.MultipleCards}
  outline: 0.0625rem solid rgba(20, 26, 30, 0.05);
  outline-offset: -0.0625rem;
  ${hotDealColorStyles}
`

const FireIcon = styled(FontAwesomeIcon)`
  margin-right: 0.25rem;
`

const FmvDealBadge = ({
  variant = 'ldp',
  'data-testid': testid = 'fmv-deal-badge',
}: FmvDealBadgeProps) => {
  const BadgeComponent = variant === 'card' ? CardDealBadge : LDPDealBadge

  return (
    <BadgeComponent type={TagType.auction} data-testid={testid}>
      <FireIcon icon={faFire} />
      <FormattedMessage id="Auction.tag.hotDeal" />
    </BadgeComponent>
  )
}

export default FmvDealBadge
